const transitionStyle = () => ({ fullHeight: { height: '100%' } });

export default transitionStyle;
